import { ReactNode } from "react";

type LabelTone =
  | "important"
  | "resolved"
  | "neutral"
  | "info"
  | "won"
  | "lost"
  | "deleted";

const TONES: Record<LabelTone, string> = {
  important: "bg-[var(--p-color-bg-fill-critical)]",
  resolved: "bg-[var(--p-color-bg-fill-success)]",
  neutral: "bg-[var(--p-color-bg-fill-tertiary)]",
  info: "bg-[var(--p-color-bg-fill-info)]",
  won: "bg-[var(--p-color-bg-fill-success)]",
  lost: "bg-[var(--p-color-bg-fill-critical)]",
  deleted: "bg-[var(--p-color-bg-fill-tertiary)]",
};

interface LabelProps {
  tone?: LabelTone;
  children: ReactNode;
}

export default function Label({ tone = "neutral", children }: LabelProps) {
  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-[11px] font-semibold leading-none text-white ${
        TONES[tone] || TONES.neutral
      }`}
    >
      {children}
    </span>
  );
}
